import ErrorBoundary from './errorBoundary.view';

export default ErrorBoundary;
